import { PatientPayersActions } from 'src/redux/actions/constant';

const {
  GET_PAYER_DATE_RANGES_SUCCESS,
  GET_PAYER_DATE_RANGES_FAILURE,
  GET_PAYER_DATE_RANGES_LOADING,
  GET_PAYER_DATE_RANGES_RESET,
} = PatientPayersActions;

const initialState: any = {
  response: null,
  loading: false,
};

export const getPayerDateRangesReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_PAYER_DATE_RANGES_SUCCESS:
      return {
        ...state,
        response: action.payload,
        loading: false,
      };

    case GET_PAYER_DATE_RANGES_FAILURE:
      return {
        ...state,
        response: null,
        loading: false,
      };

    case GET_PAYER_DATE_RANGES_LOADING:
      return {
        ...state,
        loading: true,
      };

    case GET_PAYER_DATE_RANGES_RESET:
      return initialState;

    default:
      return state;
  }
};
